import { Tabs } from 'flowbite';
import Swiper from 'swiper/bundle';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/bundle';
import '@dotlottie/player-component';

document.addEventListener('livewire:navigated', () => {
  initializeTrackCardsSwiper();
});

const reviewSwiper = new Swiper('.review-swiper', {
  modules: [Navigation, Pagination],
  centeredSlides: 'true',
  loop: true,
  grabCursor: true,
  fade: true,
  autoplay: {
    delay: 8000,
  },
  navigation: {
    nextEl: '.review-swiper-button-prev',
    prevEl: '.review-swiper-button-next',
  },
  breakpoints: {
    0: {
      slidesPerView: 'auto',
      spaceBetween: 0,
    },
    950: {
      slidesPerView: 'auto',
      spaceBetween: 32,
      loop: true,
    },
  },
});

const swiperContainerHeight =
  document.getElementById('review-container')?.offsetHeight;
const swiperSlides = document.querySelectorAll('.review-slide');
swiperSlides.forEach((slide) => {
  slide.style.height = swiperContainerHeight + 'px';
});

const blogSwiper = new Swiper('.blog-swiper', {
  modules: [Navigation],
  spaceBetween: 20,
  grabCursor: true,
  navigation: {
    nextEl: '.blog-swiper-button-prev',
    prevEl: '.blog-swiper-button-next',
  },
  breakpoints: {
    0: {
      slidesPerView: 'auto',
      spaceBetween: 0,
    },
    950: {
      slidesPerView: 'auto',
      spaceBetween: 32,
    },
  },
});

function initializeTrackCardsSwiper() {
  for (const trackCardSlider of document.querySelectorAll(
    '.track-card-swiper',
  )) {
    new Swiper(
      '.track-card-swiper[data-track="' + trackCardSlider.dataset.track + '"]',
      {
        modules: [Navigation],
        spaceBetween: 20,
        grabCursor: false,
        resistanceRatio: 0,
        loop: false,
        navigation: {
          nextEl: '.track-card-swiper-next',
          prevEl: '.track-card-swiper-prev',
        },
        slidesPerView: 'auto',
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        breakpoints: {
          0: {
            initialSlide: trackCardSlider.dataset.firstCourse,
          },
          768: {
            initialSlide: trackCardSlider.dataset.firstCourse,
          },
          900: {
            initialSlide: Math.max(trackCardSlider.dataset.firstCourse - 1, 0),
          },
          1064: {
            initialSlide: Math.max(trackCardSlider.dataset.firstCourse - 2, 0),
          },
        },
      },
    );
  }
}

initializeTrackCardsSwiper();

const projectsGallerySwiper = new Swiper('#projects-gallery', {
  effect: 'cards',
  grabCursor: true,
  cardsEffect: {
    rotate: false,
    perSlideOffset: 15,
  },
  autoplay: {
    delay: 2000,
    disableOnInteraction: true,
    reverseDirection: true,
  },
  initialSlide: Math.floor(
    document.querySelectorAll('.projects-gallery-desktop-slide').length / 2,
  ),
  slideToClickedSlide: true,
});

const projectsGalleryMobileSwiper = new Swiper(
  '.projects-gallery-swiper-mobile',
  {
    spaceBetween: 20,
    centeredSlides: 'true',
    loop: 'true',
    grabCursor: true,
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 0,
      },
      950: {
        slidesPerView: 'auto',
        spaceBetween: 32,
        loop: true,
      },
    },
    autoplay: {
      delay: 2000,
    },
  },
);
